import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {Column} from 'asax-common';
import {ColumnUnits, Units} from '../../units-formatters/units-formatters.service';

@Component({
  selector: 'asax-result-table-search-table-column-units',
  templateUrl: './column-units.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnUnitsComponent {
  @Input() column: Column;
  @Input() columnUnits: Units;

  @Output() outColumnUnits = new EventEmitter<ColumnUnits>();

  columnUnitsChanged(columnUnits: Units): void {
    this.columnUnits = columnUnits;
    this.emitColumnUnits();
  }

  emitColumnUnits(): void {
    this.outColumnUnits.emit({
      columnId: this.column.id,
      units: this.columnUnits
    });
  }
}
